<template>
    <div>
        <a @click.prevent="jumpUrl" href="https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk" class="btn-download" v-if="isMatch">Download All Football for more matches</a>
        <a @click.prevent="jumpUrl" href="https://oss-public.allfootballapp.com/resource/c23670f39a9238a1a1f4c79bd15f7a6a.apk"  class="btn-download" v-if="isArticle">{{$t('downloadForComments')}}</a>
    </div>
</template>

<script>
    export default {
        name: 'downloadFooter',
        data: function () {
            return {
                isMatch: false,
                isArticle: false
            };
        },
        methods: {
            jumpUrl: function () {
                let utilObj = require('@/util/util.js');
                if (utilObj.checkOperamini()) {
                    ga('send', 'event', 'm', 'downloadFoot', 'opreamini');
                }
                utilObj.jumpUrl();
            }
        },
        mounted: function () {
            if (window.location.href.indexOf('match') > -1) {
                this.isMatch = true;
            } else {
                this.isArticle = true;
            }
        }
    };
</script>
<style lang="less">
    .btn-download, a.btn-download {
        text-decoration: none !important;
        display: block;
        padding: .4rem;
        margin: 1.4rem .7rem 2.5rem .7rem;
        height: 1.8rem;
        line-height: 1.8rem;
        color: #fff;
        background: #16ac3a;
        border-radius: .2rem;
        text-align: center;
        font-size: 1rem;
    }
</style>



// WEBPACK FOOTER //
// downloadFooter.vue?06e84deb